import Input from "@components/inputs/input";
import { ellipsis } from "polished";
import styled from "styled-components";

export const ListRowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    position: relative;
    width: 100%;
    align-self: flex-start;
`;

export const LabelInputStyled = styled(Input)`
    max-width: 630px;
    width: 0;
    flex: 1 1 auto;
    
    input {
        display: none;
    }
`;

export const HighlightedLabelText = styled.span`
    ${ellipsis()};
    width: 100%;
`;

export const HighlightedLabelMatch = styled.span<{ $isActive: boolean }>`
    background-color: ${props => props.$isActive 
        ? props.theme.C_TEXT_emph_bg_text_highlighted : props.theme.C_TEXT_bg_text_highlighted};
    border-radius: ${props => props.theme.borderRadius};
`;
